<div class="w-full">

    @let loadingAssignments = (loading$ | async) ?? false;
    <div class="w-full flex flex-col gap-4">

        @let assignments = (assignments$ | async) ?? [];
        @let myRoles = (myRoles$ | async) ?? null;

        @for (item of assignments; track item.id) {
        <div class="bg-white shadow-lg rounded w-full px-4 py-3">
            <div class="cursor-default flex flex-col gap-2">
                <div class="flex flex-row items-start justify-between w-full mb-1 gap-4">
                    <div class="flex flex-row justify-start gap-4">
                        @if(item.type == assignmentType.pdf) {
                        <a [href]="item.assignmentUrl || null" class="flex flex-row justify-start gap-4"
                            [attr.target]="item.assignmentUrl ? '_blank' : null"
                            [attr.rel]="item.assignmentUrl ? 'noopener noreferrer' : null">
                            <div
                                [class]="item.assignmentUrl ? 'text-blue-500 hover:underline' : 'text-gray-400 cursor-not-allowed'">
                                <i class="far fa-file-pdf text-lg"></i>
                            </div>
                            <ng-container *ngTemplateOutlet="sharedContent"></ng-container>
                        </a>
                        } @else if(item.type == assignmentType.text) {
                        <a [routerLink]="[item.id]" [queryParams]="{'academicYear': academicYear}"
                            class="flex flex-row justify-start gap-4">
                            <div
                                [class]="item.assignmentUrl ? 'text-blue-500 hover:underline' : 'text-gray-400 cursor-not-allowed'">
                                <i class="far fa-file-lines text-lg"></i>
                            </div>
                            <ng-container *ngTemplateOutlet="sharedContent"></ng-container>
                        </a>
                        }
                        <ng-template #sharedContent>
                            <div class="flex flex-col">
                                <span class="text-primary-300 text-xs whitespace-nowrap">
                                    {{ item.created | moment: 'Do MMM YYYY' }}
                                </span>
                                <div class="inline-flex flex-wrap items-center">
                                    <span class="text-primary text-lg font-semibold mr-1">
                                        {{ item.lessonName }}
                                    </span>
                                </div>
                                @let expired = (item.endDate | isExpired);
                                <div class="flex flex-row gap-2 text-xs place-items-center mt-2">
                                    <span class="text-gray-500">End Date:</span>
                                    <app-btn-chip [label]="item.endDate | moment: 'Do MMM YYYY'" class="inline-flex"
                                        [color]="expired ? 'text-red-600' : 'text-green-800'"
                                        [bgColor]="expired ? 'bg-red-50' : 'bg-green-50'">
                                    </app-btn-chip>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                    @if(academicYear == group?.academicYear && (myRoles?.management || (myRoles?.faculty && item.gradeId
                    ===
                    faculty?.gradeId
                    && isTeacher && item.academicYear == group?.academicYear))) {
                    <div class="flex flex-row gap-2 whitespace-nowrap">
                        @if (item.type == assignmentType.text) {
                        <app-btn-fab (click)="onEditNotes(item)" icon="fas fa-file-signature"
                            tooltip="Edit Notes"></app-btn-fab>
                        }
                        <app-btn-fab (click)="onEditAssignment(item)" icon="fas fa-edit"
                            tooltip="Edit Assignment"></app-btn-fab>
                        <app-btn-fab (click)="onDelete(item)" icon="fa fa-trash-can"
                            textColor="text-red-500 disabled:text-gray-200" tooltip="Delete"></app-btn-fab>
                    </div>
                    }
                </div>
            </div>
        </div>
        } @empty {
        @if(!loadingAssignments) {
        <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap">
            No Assignments Found
        </div>
        }
        }
        @if(loadingAssignments) {
        <div class="bg-white shadow-lg rounded p-4 mt-1 w-full mx-auto">
            <div class="animate-pulse flex space-x-4">
                <div class="flex-1 space-y-2">
                    <div class="h-3 w-1/4 bg-slate-200 rounded"></div>
                    <div class="h-4 w-2/3 bg-slate-200 rounded"></div>
                    <div class="space-y-2">
                        <div class="grid grid-cols-3 gap-4 mb-2">
                            <div class="h-4 bg-slate-200 rounded col-span-2"></div>
                            <div class="h-4 bg-slate-200 rounded col-span-1"></div>
                        </div>
                        <div class="flex flex-row gap-2 justify-start items-center">
                            <div class="h-6 w-6 bg-slate-200 rounded-full"></div>
                            <div class="h-4 w-1/4 bg-slate-200 rounded"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>

    @if(!loadingAssignments && (assignments?.length ?? 0) > 0) {
    <div class="flex flex-row w-full justify-center px-4 mt-3">
        <app-btn-more (click)="addMore()" [isDisabled]="loadingAssignments || groupId == null"></app-btn-more>
    </div>
    }
</div>